var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_49873)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58463 19.9979L4.97749 18.7064C5.30878 18.4164 5.73695 18.2613 6.17731 18.2719L12.083 18.413L17.784 13.0403L17.3572 12.6135C16.2199 11.4762 14.3801 11.4694 13.2344 12.5933L11.4165 14.1016H7.07033V15.2734H11.8394L14.0235 13.4614L14.0427 13.4421C14.5784 12.9065 15.3738 12.7888 16.0235 13.0891L11.6296 17.2299L6.20546 17.1004C6.20543 17.1004 6.20549 17.1004 6.20546 17.1004C5.46787 17.0827 4.75062 17.3439 4.19724 17.832L4.19177 17.8368L3.57275 18.4108L1.69523 16.7214L4.89097 13.4421C5.22037 13.1139 5.66638 12.9297 6.13142 12.9297V11.7578C5.35443 11.7578 4.60925 12.0665 4.05982 12.6159L4.05449 12.6213L0.00488281 16.7769L3.58463 19.9979Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.586 2.34375C6.37911 2.34375 2.92971 5.79315 2.92971 10H4.10158C4.10158 6.44036 7.02632 3.51563 10.586 3.51563C14.1414 3.51563 17.0313 6.43613 17.0313 10H18.2031C18.2031 5.79739 14.797 2.34375 10.586 2.34375Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.44379 10.5859H18.7231C18.473 11.2633 17.8047 11.7578 17.0313 11.7578H4.10158C3.33622 11.7578 2.6851 11.2687 2.44379 10.5859ZM1.17189 10C1.17189 11.618 2.48356 12.9297 4.10158 12.9297H17.0313C18.6366 12.9297 20 11.6305 20 10V9.41406H1.17189V10Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82814 1.75781C8.82814 2.7286 9.61516 3.51563 10.586 3.51563C11.5567 3.51563 12.3438 2.7286 12.3438 1.75781C12.3438 0.787021 11.5567 0 10.586 0C9.61516 0 8.82814 0.787021 8.82814 1.75781ZM10.586 2.34375C10.2624 2.34375 10 2.0814 10 1.75781C10 1.43423 10.2624 1.17188 10.586 1.17188C10.9095 1.17188 11.1719 1.43423 11.1719 1.75781C11.1719 2.0814 10.9095 2.34375 10.586 2.34375Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82928 12.9297C9.7991 12.9297 10.586 13.7169 10.586 14.6875H11.7578C11.7578 13.0704 10.447 11.7578 8.82928 11.7578V12.9297Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_49873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.a1d4888c32786d880f44c23fb8b6d14e.svg";
export { ForwardRef as ReactComponent };